//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InventorySub from'./components/inventorySub.vue'
import Dolong from'./components/dolong.vue'
export default {
  components:{
    InventorySub,
    Dolong,
  },
  data() {
    return {
      tableData:[],
      invSub:false,
      pageNo:1,
      total:10,
      allMoney:'',
      count:'',
      isDolong:false,
      orderId:0,
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(val=1){
      this.pageNo = val
      let data = {
        pageNo:this.pageNo,
        pageSize:10,
        dShopId:this.$route.query.shopId
      }
      this.$axios.post('/mtea/stock/dealer/shopping/historyList',data).then(res => {
        res.list.records.forEach(e => {
          e.payAmount = e.payAmount/100
        });
        this.allMoney = res.allMoney
        this.count = res.count
        this.tableData = res.list.records
        this.total = res.list.total
      })
    },
    handleClick(row){
      console.log('刷新',row)
      this.orderId = row
      this.isDolong = true
    },
    refresh(){
      console.log('刷新')
      this.invSub = true
    },
    invSubState(){
      this.invSub = false
      this.isDolong =false
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
  }
}
